import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const APIConfigPanel = () => {
  const [showKeys, setShowKeys] = useState({});
  const [apiConfigs, setApiConfigs] = useState({
    facebook: {
      appId: '**********************',
      appSecret: '**********************',
      accessToken: '**********************'
    },
    instagram: {
      businessAccountId: '**********************',
      accessToken: '**********************'
    },
    whatsapp: {
      phoneNumberId: '**********************',
      accessToken: '**********************'
    },
    linkedin: {
      clientId: '**********************',
      clientSecret: '**********************',
      accessToken: '**********************'
    }
  });

  const toggleShowKey = (platform) => {
    setShowKeys({ ...showKeys, [platform]: !showKeys?.[platform] });
  };

  const handleSaveConfig = (platform) => {
    console.log(`Saving ${platform} configuration:`, apiConfigs?.[platform]);
    // TODO: Save to Supabase with encryption
  };

  return (
    <div className="space-y-6">
      {/* Facebook Configuration */}
      <div className="card p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold text-foreground flex items-center">
            <Icon name="Facebook" size={24} className="mr-2 text-blue-600" />
            Configuración de Facebook
          </h2>
          <Button variant="outline" size="sm" iconName="ExternalLink">
            Documentación
          </Button>
        </div>

        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              App ID
            </label>
            <div className="flex items-center space-x-2">
              <Input
                type={showKeys?.facebook ? 'text' : 'password'}
                value={apiConfigs?.facebook?.appId}
                onChange={(e) =>
                  setApiConfigs({
                    ...apiConfigs,
                    facebook: { ...apiConfigs?.facebook, appId: e?.target?.value }
                  })
                }
                placeholder="Ingresa tu Facebook App ID"
              />
              <Button
                variant="ghost"
                size="sm"
                iconName={showKeys?.facebook ? 'EyeOff' : 'Eye'}
                onClick={() => toggleShowKey('facebook')}
              />
            </div>
          </div>

          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              App Secret
            </label>
            <Input
              type="password"
              value={apiConfigs?.facebook?.appSecret}
              onChange={(e) =>
                setApiConfigs({
                  ...apiConfigs,
                  facebook: { ...apiConfigs?.facebook, appSecret: e?.target?.value }
                })
              }
              placeholder="Ingresa tu Facebook App Secret"
            />
          </div>

          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Access Token
            </label>
            <Input
              type="password"
              value={apiConfigs?.facebook?.accessToken}
              onChange={(e) =>
                setApiConfigs({
                  ...apiConfigs,
                  facebook: { ...apiConfigs?.facebook, accessToken: e?.target?.value }
                })
              }
              placeholder="Ingresa tu Facebook Access Token"
            />
          </div>

          <Button fullWidth iconName="Save" onClick={() => handleSaveConfig('facebook')}>
            Guardar Configuración de Facebook
          </Button>
        </div>
      </div>

      {/* Instagram Configuration */}
      <div className="card p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold text-foreground flex items-center">
            <Icon name="Instagram" size={24} className="mr-2 text-pink-600" />
            Configuración de Instagram
          </h2>
          <Button variant="outline" size="sm" iconName="ExternalLink">
            Documentación
          </Button>
        </div>

        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Business Account ID
            </label>
            <Input
              type="text"
              value={apiConfigs?.instagram?.businessAccountId}
              onChange={(e) =>
                setApiConfigs({
                  ...apiConfigs,
                  instagram: { ...apiConfigs?.instagram, businessAccountId: e?.target?.value }
                })
              }
              placeholder="Ingresa tu Instagram Business Account ID"
            />
          </div>

          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Access Token
            </label>
            <Input
              type="password"
              value={apiConfigs?.instagram?.accessToken}
              onChange={(e) =>
                setApiConfigs({
                  ...apiConfigs,
                  instagram: { ...apiConfigs?.instagram, accessToken: e?.target?.value }
                })
              }
              placeholder="Ingresa tu Instagram Access Token"
            />
          </div>

          <Button fullWidth iconName="Save" onClick={() => handleSaveConfig('instagram')}>
            Guardar Configuración de Instagram
          </Button>
        </div>
      </div>

      {/* WhatsApp Configuration */}
      <div className="card p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold text-foreground flex items-center">
            <Icon name="MessageCircle" size={24} className="mr-2 text-green-600" />
            Configuración de WhatsApp Business
          </h2>
          <Button variant="outline" size="sm" iconName="ExternalLink">
            Documentación
          </Button>
        </div>

        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Phone Number ID
            </label>
            <Input
              type="text"
              value={apiConfigs?.whatsapp?.phoneNumberId}
              onChange={(e) =>
                setApiConfigs({
                  ...apiConfigs,
                  whatsapp: { ...apiConfigs?.whatsapp, phoneNumberId: e?.target?.value }
                })
              }
              placeholder="Ingresa tu WhatsApp Phone Number ID"
            />
          </div>

          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Access Token
            </label>
            <Input
              type="password"
              value={apiConfigs?.whatsapp?.accessToken}
              onChange={(e) =>
                setApiConfigs({
                  ...apiConfigs,
                  whatsapp: { ...apiConfigs?.whatsapp, accessToken: e?.target?.value }
                })
              }
              placeholder="Ingresa tu WhatsApp Access Token"
            />
          </div>

          <Button fullWidth iconName="Save" onClick={() => handleSaveConfig('whatsapp')}>
            Guardar Configuración de WhatsApp
          </Button>
        </div>
      </div>

      {/* LinkedIn Configuration */}
      <div className="card p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold text-foreground flex items-center">
            <Icon name="Linkedin" size={24} className="mr-2 text-blue-700" />
            Configuración de LinkedIn
          </h2>
          <Button variant="outline" size="sm" iconName="ExternalLink">
            Documentación
          </Button>
        </div>

        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Client ID
            </label>
            <Input
              type="text"
              value={apiConfigs?.linkedin?.clientId}
              onChange={(e) =>
                setApiConfigs({
                  ...apiConfigs,
                  linkedin: { ...apiConfigs?.linkedin, clientId: e?.target?.value }
                })
              }
              placeholder="Ingresa tu LinkedIn Client ID"
            />
          </div>

          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Client Secret
            </label>
            <Input
              type="password"
              value={apiConfigs?.linkedin?.clientSecret}
              onChange={(e) =>
                setApiConfigs({
                  ...apiConfigs,
                  linkedin: { ...apiConfigs?.linkedin, clientSecret: e?.target?.value }
                })
              }
              placeholder="Ingresa tu LinkedIn Client Secret"
            />
          </div>

          <div>
            <label className="text-sm font-medium text-foreground mb-2 block">
              Access Token
            </label>
            <Input
              type="password"
              value={apiConfigs?.linkedin?.accessToken}
              onChange={(e) =>
                setApiConfigs({
                  ...apiConfigs,
                  linkedin: { ...apiConfigs?.linkedin, accessToken: e?.target?.value }
                })
              }
              placeholder="Ingresa tu LinkedIn Access Token"
            />
          </div>

          <Button fullWidth iconName="Save" onClick={() => handleSaveConfig('linkedin')}>
            Guardar Configuración de LinkedIn
          </Button>
        </div>
      </div>
    </div>
  );
};

export default APIConfigPanel;
